<template lang="pug">
    v-card.page-card
        v-card-text
            v-form(v-model="formValid" ref="resetemailform")
                //- v-alert.mb-6(dense outlined type="error") 
                Alert
                //- .alert-text.mb-6 請重新設定你的密碼，並以新密碼登入 {{email}} 此帳號
                v-text-field.page-input-field(v-model="password" solo dense outlined :rules="[rules.required, rules.password]" :placeholder="$t('Auth.__SetNewPassword')" type="password" )
                v-text-field.page-input-field(v-model="confirmedPassword" solo dense outlined :rules="[rules.required, rules.password]" :placeholder="$t('Auth.__ConfirmNewPassword')" type="password" )
                v-btn.page-btn.mb-4(block rounded color="primary" @click="resetPassword") {{$t('Auth.__ResetYourPassword')}}
                        

</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  data: () => ({
    formValid: false,
    email: "email@makeuwow.com",
    password: "",
    confirmedPassword: "",
    description: "",
    token: "",
    rules: textfieldUtils.rules
  }),
  methods: {
    resetPassword() {
      this.$refs.resetemailform.validate()
      if (this.formValid) {
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("auth/resetPassword", {
            token: this.token,
            password: this.password,
            confirmedPassword: this.confirmedPassword
          })
          .then(
            function(response) {
              // this.$store.dispatch("global/showAlert", {
              //     type: "success",
              //     message: ""
              // })
              this.$router.push({
                name: "Login",
                params: {
                  alert: {
                    message: this.$t("Messages.__SuccessfullyReset"),
                    type: "success"
                  }
                }
              })
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
            }.bind(this)
          )
        this.$store.dispatch("global/stopLoading")
      }
    }
  },
  created() {
    this.token = this.$route.query.token
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/login.scss";
</style>
